import React from 'react';

import scss from './AppBanner.module.scss';
import { getAsset } from '@helper/getConfigValues';

interface AppBannerProps {
    isDark?: boolean;
}

const AppBanner = ({ isDark = true }: AppBannerProps) => {
    return isDark ? <AppBannerDark /> : <AppBannerLight />;
}

const AppBannerButtons = () => (
    <div className={scss.buttons}>
        <a href={'https://apps.apple.com/au/app/wedding-planner-easy-weddings/id433611621'} target={'_blank'}>
            <img src={getAsset("badges/ios-app-store.png")} />
        </a>
        <a href={'https://play.google.com/store/apps/details?id=au.com.easyweddings.directory'} target={'_blank'}>
            <img src={getAsset("badges/google-play-store.png")} />
        </a>
    </div>
);

const AppBannerDark = () => (
    <div className={scss.bannerDark} style={{ backgroundImage: `url(${getAsset("backgrounds/app-banner.jpg")})` }}>
        <div className={scss.text}>Plan your wedding on<br className="d-lg-none d-xl-block"/> the go with our app!</div>
        <AppBannerButtons />
    </div>
);

const AppBannerLight = () => {
    return (
        <div className={scss.bannerLight}>
            <div className={scss.image}>
                <img src={getAsset("images/planning-app.png")} />
            </div>
            <div className={scss.text}>Download our free wedding planning app now!</div>
            <AppBannerButtons />
        </div>
    );
};

export default AppBanner;
